import { t } from '@lingui/macro';

export function countryIdToName(id: CountryIsoCode, prefix = false): string {
  const countryNames = {
    AR: t({ id: 'common.country.argentina', message: 'Argentina', comment: 'Argentina' }),
    BD: t({ id: 'common.country.bangladesh', message: 'Bangladesh', comment: 'Bangladesh' }),
    BR: t({ id: 'common.country.brazil', message: 'Brazil', comment: 'Brazil' }),
    CM: t({ id: 'common.country.cameroon', message: 'Cameroon', comment: 'Cameroon' }),
    ET: t({ id: 'common.country.ethiopia', message: 'Ethiopia', comment: 'Ethiopia' }),
    FR: t({ id: 'common.country.france', message: 'France', comment: 'France' }),
    DE: t({ id: 'common.country.germany', message: 'Germany', comment: 'Germany' }),
    IN: t({ id: 'common.country.india', message: 'India', comment: 'India' }),
    ID: t({ id: 'common.country.indonesia', message: 'Indonesia', comment: 'Indonesia' }),
    JP: t({ id: 'common.country.japan', message: 'Japan', comment: 'Japan' }),
    KE: t({ id: 'common.country.kenya', message: 'Kenya', comment: 'Kenya' }),
    LB: t({ id: 'common.country.lebanon', message: 'Lebanon', comment: 'Lebanon' }),
    ML: t({ id: 'common.country.mali', message: 'Mali', comment: 'Mali' }),
    MA: t({ id: 'common.country.morocco', message: 'Morocco', comment: 'Morocco' }),
    NG: t({ id: 'common.country.nigeria', message: 'Nigeria', comment: 'Nigeria' }),
    PE: t({ id: 'common.country.peru', message: 'Peru', comment: 'Peru' }),
    ES: t({ id: 'common.country.spain', message: 'Spain', comment: 'Spain' }),
    UA: t({ id: 'common.country.ukraine', message: 'Ukraine', comment: 'Ukraine' }),
    UK: t({
      id: 'common.country.united-kingdom',
      message: 'United Kingdom',
      comment: 'United Kingdom',
    }),
    US: t({ id: 'common.country.usa', message: 'USA', comment: 'USA' }),
    ZW: t({ id: 'common.country.zimbabwe', message: 'Zimbabwe', comment: 'Zimbabwe' }),
    AF: t({ id: 'common.country.afghanistan', message: 'Afghanistan', comment: 'Afghanistan' }),
    AZ: t({ id: 'common.country.azerbaijan', message: 'Azerbaijan', comment: 'Azerbaijan' }),
    KH: t({ id: 'common.country.cambodia', message: 'Cambodia', comment: 'Cambodia' }),
    CO: t({ id: 'common.country.colombia', message: 'Colombia', comment: 'Colombia' }),
    CI: t({
      id: 'common.country.cote-d-ivoire',
      message: "Côte d'Ivoire",
      comment: "Côte d'Ivoire",
    }),
    EG: t({ id: 'common.country.egypt', message: 'Egypt', comment: 'Egypt' }),
    GH: t({ id: 'common.country.ghana', message: 'Ghana', comment: 'Ghana' }),
    GR: t({ id: 'common.country.greece', message: 'Greece', comment: 'Greece' }),
    GT: t({ id: 'common.country.guatemala', message: 'Guatemala', comment: 'Guatemala' }),
    IQ: t({ id: 'common.country.iraq', message: 'Iraq', comment: 'Iraq' }),
    JO: t({ id: 'common.country.jordan', message: 'Jordan', comment: 'Jordan' }),
    MW: t({ id: 'common.country.malawi', message: 'Malawi', comment: 'Malawi' }),
    MY: t({ id: 'common.country.malaysia', message: 'Malaysia', comment: 'Malaysia' }),
    MX: t({ id: 'common.country.mexico', message: 'Mexico', comment: 'Mexico' }),
    MZ: t({ id: 'common.country.mozambique', message: 'Mozambique', comment: 'Mozambique' }),
    MM: t({ id: 'common.country.myanmar', message: 'Myanmar', comment: 'Myanmar' }),
    NP: t({ id: 'common.country.nepal', message: 'Nepal', comment: 'Nepal' }),
    PK: t({ id: 'common.country.pakistan', message: 'Pakistan', comment: 'Pakistan' }),
    RO: t({ id: 'common.country.romania', message: 'Romania', comment: 'Romania' }),
    RU: t({
      id: 'common.country.russian-federation',
      message: 'Russian Federation',
      comment: 'Russian Federation',
    }),
    SN: t({ id: 'common.country.senegal', message: 'Senegal', comment: 'Senegal' }),
    SL: t({ id: 'common.country.sierra-leone', message: 'Sierra Leone', comment: 'Sierra Leone' }),
    ZA: t({ id: 'common.country.south-africa', message: 'South Africa', comment: 'South Africa' }),
    KR: t({
      id: 'common.country.korea',
      message: 'Republic of Korea',
      comment: 'Republic of Korea',
    }),
    TJ: t({ id: 'common.country.tajikistan', message: 'Tajikistan', comment: 'Tajikistan' }),
    TZ: t({
      id: 'common.country.tanzania',
      message: 'United Republic of Tanzania',
      comment: 'United Republic of Tanzania',
    }),
    TH: t({ id: 'common.country.thailand', message: 'Thailand', comment: 'Thailand' }),
    TN: t({ id: 'common.country.tunisia', message: 'Tunisia', comment: 'Tunisia' }),
    TR: t({ id: 'common.country.turkiye', message: 'Türkiye', comment: 'Türkiye' }),
    UG: t({ id: 'common.country.uganda', message: 'Uganda', comment: 'Uganda' }),
    VE: t({ id: 'common.country.venezuela', message: 'Venezuela', comment: 'Venezuela' }),
    VN: t({ id: 'common.country.viet-nam', message: 'Viet Nam', comment: 'Viet Nam' }),
    YE: t({ id: 'common.country.yemen', message: 'Yemen', comment: 'Yemen' }),
  };

  const countryNamesIn = {
    AR: t({ id: 'common.country.in-argentina', message: 'in Argentina', comment: 'Argentina' }),
    BD: t({ id: 'common.country.in-bangladesh', message: 'in Bangladesh', comment: 'Bangladesh' }),
    BR: t({ id: 'common.country.in-brazil', message: 'in Brazil', comment: 'Brazil' }),
    CM: t({ id: 'common.country.in-cameroon', message: 'in Cameroon', comment: 'Cameroon' }),
    ET: t({ id: 'common.country.in-ethiopia', message: 'in Ethiopia', comment: 'Ethiopia' }),
    FR: t({ id: 'common.country.in-france', message: 'in France', comment: 'France' }),
    DE: t({ id: 'common.country.in-germany', message: 'in Germany', comment: 'Germany' }),
    IN: t({ id: 'common.country.in-india', message: 'in India', comment: 'India' }),
    ID: t({ id: 'common.country.in-indonesia', message: 'in Indonesia', comment: 'Indonesia' }),
    JP: t({ id: 'common.country.in-japan', message: 'in Japan', comment: 'Japan' }),
    KE: t({ id: 'common.country.in-kenya', message: 'in Kenya', comment: 'Kenya' }),
    LB: t({ id: 'common.country.in-lebanon', message: 'in Lebanon', comment: 'Lebanon' }),
    ML: t({ id: 'common.country.in-mali', message: 'in Mali', comment: 'Mali' }),
    MA: t({ id: 'common.country.in-morocco', message: 'in Morocco', comment: 'Morocco' }),
    NG: t({ id: 'common.country.in-nigeria', message: 'in Nigeria', comment: 'Nigeria' }),
    PE: t({ id: 'common.country.in-peru', message: 'in Peru', comment: 'Peru' }),
    ES: t({ id: 'common.country.in-spain', message: 'in Spain', comment: 'Spain' }),
    UA: t({ id: 'common.country.in-ukraine', message: 'in Ukraine', comment: 'Ukraine' }),
    UK: t({
      id: 'common.country.in-united-kingdom',
      message: 'in the United Kingdom',
      comment: 'United Kingdom',
    }),
    US: t({ id: 'common.country.in-usa', message: 'in the USA', comment: 'USA' }),
    ZW: t({ id: 'common.country.in-zimbabwe', message: 'in Zimbabwe', comment: 'Zimbabwe' }),
    AF: t({
      id: 'common.country.in-afghanistan',
      message: 'in Afghanistan',
      comment: 'Afghanistan',
    }),
    AZ: t({ id: 'common.country.in-azerbaijan', message: 'in Azerbaijan', comment: 'Azerbaijan' }),
    KH: t({ id: 'common.country.in-cambodia', message: 'in Cambodia', comment: 'Cambodia' }),
    CO: t({ id: 'common.country.in-colombia', message: 'in Colombia', comment: 'Colombia' }),
    CI: t({
      id: 'common.country.in-cote-d-ivoire',
      message: "in Côte d'Ivoire",
      comment: "Côte d'Ivoire",
    }),
    EG: t({ id: 'common.country.in-egypt', message: 'in Egypt', comment: 'Egypt' }),
    GH: t({ id: 'common.country.in-ghana', message: 'in Ghana', comment: 'Ghana' }),
    GR: t({ id: 'common.country.in-greece', message: 'in Greece', comment: 'Greece' }),
    GT: t({ id: 'common.country.in-guatemala', message: 'in Guatemala', comment: 'Guatemala' }),
    IQ: t({ id: 'common.country.in-iraq', message: 'in Iraq', comment: 'Iraq' }),
    JO: t({ id: 'common.country.in-jordan', message: 'in Jordan', comment: 'Jordan' }),
    MW: t({ id: 'common.country.in-malawi', message: 'in Malawi', comment: 'Malawi' }),
    MY: t({ id: 'common.country.in-malaysia', message: 'in Malaysia', comment: 'Malaysia' }),
    MX: t({ id: 'common.country.in-mexico', message: 'in Mexico', comment: 'Mexico' }),
    MZ: t({ id: 'common.country.in-mozambique', message: 'in Mozambique', comment: 'Mozambique' }),
    MM: t({ id: 'common.country.in-myanmar', message: 'in Myanmar', comment: 'Myanmar' }),
    NP: t({ id: 'common.country.in-nepal', message: 'in Nepal', comment: 'Nepal' }),
    PK: t({ id: 'common.country.in-pakistan', message: 'in Pakistan', comment: 'Pakistan' }),
    RO: t({ id: 'common.country.in-romania', message: 'in Romania', comment: 'Romania' }),
    RU: t({
      id: 'common.country.in-russian-federation',
      message: 'in Russian Federation',
      comment: 'Russian Federation',
    }),
    SN: t({ id: 'common.country.in-senegal', message: 'in Senegal', comment: 'Senegal' }),
    SL: t({
      id: 'common.country.in-sierra-leone',
      message: 'in Sierra Leone',
      comment: 'Sierra Leone',
    }),
    ZA: t({
      id: 'common.country.in-south-africa',
      message: 'in South Africa',
      comment: 'South Africa',
    }),
    KR: t({ id: 'common.country.in-korea', message: 'in the Republic of Korea', comment: 'Korea' }),
    TJ: t({ id: 'common.country.in-tajikistan', message: 'in Tajikistan', comment: 'Tajikistan' }),
    TZ: t({
      id: 'common.country.in-tanzania',
      message: 'in the United Republic of Tanzania',
      comment: 'Tanzania',
    }),
    TH: t({ id: 'common.country.in-thailand', message: 'in Thailand', comment: 'Thailand' }),
    TN: t({ id: 'common.country.in-tunisia', message: 'in Tunisia', comment: 'Tunisia' }),
    TR: t({ id: 'common.country.in-turkiye', message: 'in Türkiye', comment: 'Türkiye' }),
    UG: t({ id: 'common.country.in-uganda', message: 'in Uganda', comment: 'Uganda' }),
    VE: t({ id: 'common.country.in-venezuela', message: 'in Venezuela', comment: 'Venezuela' }),
    VN: t({ id: 'common.country.in-viet-nam', message: 'in Viet Nam', comment: 'Viet Nam' }),
    YE: t({ id: 'common.country.in-yemen', message: 'in Yemen', comment: 'Yemen' }),
  };

  const names = prefix ? countryNamesIn : countryNames;

  const value = id in names ? names[id as keyof typeof names] : id;

  return value;
}
